import {
  Chapter,
  type ChapterHistoryParams,
  NovelHistory,
  type NovelHistoryListParams,
} from "~/src/api";
import { type AuthFunction } from "~/utils/tanstack/global";
import { queryOptions } from "@tanstack/vue-query";
import { useCacheTimings } from "~/composables/cacheTiming";

export const useNovelHistory = (
  params: MaybeRefOrGetter<NovelHistoryListParams> = {},
  auth: AuthFunction,
) => {
  const unorderedParams = computed(() => {
    const paramsValue = toValue(params);
    return {
      ...paramsValue,
      authed: !!auth || undefined,
    };
  });

  return queryOptions({
    queryKey: ["novel_reading_history_entry", "collection", unorderedParams],
    queryFn: async () => {
      const paramsValue = toValue(params);
      return await NovelHistory.find(paramsValue, (await auth()) || undefined);
    },
    staleTime: useCacheTimings().collection.novel_reading_history_entry,
  });
};

export const useChapterHistory = (
  params: MaybeRefOrGetter<ChapterHistoryParams> = {},
  auth: AuthFunction,
) => {
  const unorderedParams = computed(() => {
    const paramsValue = toValue(params);
    return {
      ...paramsValue,
      authed: !!auth || undefined,
    };
  });

  return queryOptions({
    queryKey: ["reading_history_entry", "collection", unorderedParams],
    queryFn: async () => {
      const paramsValue = toValue(params);
      return await Chapter.getHistory(paramsValue, (await auth()) || "");
    },
    staleTime: useCacheTimings().collection.reading_history_entry,
  });
};
